<template>
    <div style="height:100%;">
        <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(2215,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
         Browse {{activeDiseaseFull}}
        </p>
        <el-card style="width:100%;
               height:200px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               /* background-color: rgba(255,208,75,0.05); */
               color: rgb(250,170,0);
               font-size: 14px;">
               <div style="width:49%;display: inline-block;vertical-align: middle;margin:auto;font-size: 16px;text-align: left;line-height: 23px;">
                <strong style="font-size:20px;text-transform:capitalize;">{{activeDiseaseFull}}</strong>{{activeIntroduction}}
                <a :href="'./file/MDDOmics_' + this.activeDisease+'.zip'" >download multi-omics data  </a>
               </div>
               <BarchartVue ref="gene_bar" :barData="barData" style="width:50%;height:170px;margin:auto;display: inline-block;vertical-align: middle;"/>
        </el-card>    
        <el-tabs style="height:100%;margin-top: 50px;" type="border-card" v-model="activeOmics" @tab-click="handleClick">
        <!-- SNP -->
            <el-tab-pane label="SNP" name="snp" id="snp">
                <el-table :data="tableData"  ref="snpTable" style="width: 98%;margin: auto;" height=500px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in snpFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">          
                        <template v-if="item.key === 'pmid'" v-slot="scope">
                        <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                        </template>
                     </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <a style="align-self: center; margin-left:auto;margin-right:10px"
                        href="javascript:void(0)" 
                        @click="download()">download</a>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="align-self: center;">
                    </el-pagination>
                </div>
                <div style="text-align:left;margin:1%;line-height: 25px;">
                    *Score_dgn: The VDA score from DisGENET, scoreing the SNP-disease association according to its evidence level.<br/>
                    *Disease-CUI: The disease phenotype and its concept ID from UMLS the gene associated with when collected from DisGENET.<br/>
                    *Source: The database where the SNP was collected. 'manual retrieval' means retrieved manually from literature.
                </div>
            </el-tab-pane>
        <!-- gene -->
            <el-tab-pane label="Gene" name="gene" id="gene">
                <el-table :data="tableData"  ref="geneTable" style="width: 98%;margin: auto;" height=500px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in geneFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">          
                        <template v-if="item.key === 'pmid'" v-slot="scope">
                        <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                        </template>
                     </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <a style="align-self: center; margin-left:auto;margin-right:10px"
                        href="javascript:void(0)" 
                        @click="download()">download</a>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="align-self: center;">
                    </el-pagination>
                </div>
                <div style="text-align:left;margin:1%;line-height: 25px;">
                    *Score_dgn: The GDA score from DisGENET, scoreing the gene-disease association according to its evidence level.<br/>
                    *Disease-CUI: The disease phenotype and its concept ID from UMLS the gene associated with when collected from DisGENET.<br/>
                    *Source: The database where the gene was collected. 'manual retrieval' means retrieved manually from literature.
                </div>
            </el-tab-pane>
        <!-- RNA -->
            <el-tab-pane label="ncRNA" name="rna" id="rna">
                <el-table :data="tableData"  ref="rnaTable" style="width: 98%;margin: auto;" height=500px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in rnaFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">        
                        <template v-if="item.key === 'pmid'" v-slot="scope">
                        <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <a style="align-self: center; margin-left:auto;margin-right:10px"
                        href="javascript:void(0)" 
                        @click="download()">download</a>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="align-self: center;">
                    </el-pagination>
                </div>
                <div style="text-align:left;margin:1%;line-height: 25px;">
                    *Score_dgn: The GDA score from DisGENET, scoreing the gene-disease association according to its evidence level.<br/>
                    *Score_rd4: The score from RNADisease v4.0, scoreing the RNA-disease association according to its evidence level.<br/>
                    *Disease-CUI: The disease phenotype and its concept ID from UMLS the gene associated with when collected from DisGENET.<br/>
                    *Source: The database where the gene was collected. 'manual retrieval' means retrieved manually from literature.<br/>
                    *Gene name: Most of which are gene symbols from the HGNC database. Some are LNCipedia gene IDs from LNCipedia.<br/>
                    *Original name: Original gene/RNA names from literature that are not mapped to gene symbol or LNCipedia gene ID.
                </div>
            </el-tab-pane>
        <!-- Methylation -->
            <el-tab-pane label="Methylation" name="methylation" v-if="this.activeDisease == 'MDD'||this.activeDisease == 'SZ'" id="methylation">
                <el-table :data="tableData"   ref="methylationTable" style="width: 98%;margin: auto;" height=500px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in methylationFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">  
                        <template v-if="item.key === 'pmid'" v-slot="scope">
                        <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                        </template>
                     </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <a style="align-self: center; margin-left:auto;margin-right:10px"
                        href="javascript:void(0)" 
                        @click="download()">download</a>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="align-self: center;">
                    </el-pagination>
                </div>
                <div style="text-align:left;margin:1%;line-height: 25px;">
                    *Source: The database where the gene was collected. 'manual retrieval' means retrieved manually from literature.<br/>
                </div>
            </el-tab-pane>
        <!-- Metabolite -->
            <el-tab-pane label="Mebatoblite" name="metabolite" v-if="this.activeDisease == 'MDD'" id="metabolite">
                <el-table :data="tableData"   ref="metaboliteTable" style="width: 98%;margin: auto;" height=500px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in metaboliteFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">            
                        <template v-if="item.key === 'pmid'" v-slot="scope">
                        <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                        </template>
                     </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <a style="align-self: center; margin-left:auto;margin-right:10px"
                        href="javascript:void(0)" 
                        @click="download()">download</a>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="align-self: center;">
                    </el-pagination>
                </div>
                <div style="text-align:left;margin:1%;line-height: 25px;">
                    *Group: The comparison groups for each metabolite, from proMENDA.<br/>
                    *Categories: A total of 18 categories from proMENDA, including 11 categories of human MDD and 6 categories of animal models.<br/>
                    *Regulated: The metabolite was up or down-regulated.
                </div>
            </el-tab-pane>
        <!-- Protein -->
            <el-tab-pane label="Protein" name="protein" v-if="this.activeDisease == 'MDD'" id="protein">
                <el-table :data="tableData"   ref="proteinTable" style="width: 98%;margin: auto;" height=500px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in proteinFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">           
                        <template v-if="item.key === 'pmid'" v-slot="scope">
                        <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                        </template>
                     </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <a style="align-self: center; margin-left:auto;margin-right:10px"
                        href="javascript:void(0)" 
                        @click="download()">download</a>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10,20,30]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        style="align-self: center;">
                    </el-pagination>
                </div>
                <div style="text-align:left;margin:1%;line-height: 25px;">
                    *Group: The comparison groups for each protein, from proMENDA.<br/>
                    *Categories: A total of 18 categories from proMENDA, including 11 categories of human MDD and 6 categories of animal models.<br/>
                    *Regulated: The protein was up or down-regulated.
                </div>
            </el-tab-pane>
        </el-tabs>
        <div id="plot" style="height: 800px; ">
            <KnowledgechartVue v-if="dataReady"  :nodes="nodes"  :full_edges="edges"></KnowledgechartVue>
            <!-- :inter_edges="inter_edges" -->
        </div>
    </div>
</template>
    
<script>
import BarchartVue from '../chart/Barchart.vue'
import{Loading}from'element-ui';
import KnowledgechartVue from '../chart/Knowledgechart.vue'
export default {
  components: { BarchartVue,KnowledgechartVue },
    data(){
        return{
            dataReady:false,
            tableData:[],
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:1,
            // 默认每页显示的条数（可修改）
            pageSize:10,
            desc:null,
            sortby:null,
            activeDisease: this.$route.query,
            activeOmics:"snp",
            activeDiseaseFull:"",
            activeIntroduction:"",
            geneFields: [
                { key: "gene_id", label: "Gene ID", sortable: true,width:100},
                { key: "gene_name", label: "Gene name", sortable: true,width:120},
                { key: "source", label: "Source", sortable: true,width:120},
                { key: "pmid", label: "PMID", sortable: true,minWidth:370},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,width:130},
                { key: "gene_type", label: "Gene type", sortable: true,width:120},
                { key: "score_dgn", label: "Score_dgn", sortable: true,width:120},
                { key: "map_location", label: "Map location", sortable: true,width:130},
                { key: "chromosome", label: "Chromosome", sortable: true,width:140},
                { key: "start", label: "Start",sortable: true,width:95},
                { key: "end", label: "End", sortable: true,width:95},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,width:250},
                
            ],
            rnaFields: [
                { key: "gene_id", label: "Gene ID", sortable: true,width:100},
                { key: "gene_name", label: "Gene name", sortable: true,width:120},
                { key: "source", label: "Source", sortable: true,width:120},
                { key: "pmid", label: "PMID", sortable: true,minWidth:200},
                { key: "rna_name", label: "Original name", sortable: true,width:140},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,width:130},
                { key: "gene_type", label: "RNA type", sortable: true,width:120},
                { key: "score_dgn", label: "Score_dgn", sortable: true,width:120},
                { key: "score_rd4", label: "Score_rd4", sortable: true,width:120},
                { key: "map_location", label: "Map location", sortable: true,width:130},
                { key: "chromosome", label: "Chromosome", sortable: true,width:140},
                { key: "start", label: "Start",sortable: true,width:95},
                { key: "end", label: "End", sortable: true,width:95},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,width:130},
            ],
            snpFields: [
                { key: "snp", label: "SNP ID", sortable: true,width:120},
                { key: "source", label: "Source", sortable: true,width:120},
                { key: "pmid", label: "PMID", sortable: true,minWidth:200},
                { key: "allele", label: "Allele", sortable: true,width:120},
                { key: "score_dgn", label: "Score_dgn", sortable: true,width:120},
                { key: "chromosome", label: "Chromosome", sortable: true,width:140},
                { key: "position", label: "Position",sortable: true,width:100},
                { key: "gene", label: "Gene", sortable: true,width:120},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,width:150},
                
            ], 
            methylationFields: [
                { key: "probe", label: "Probe ID", sortable: true,width:120},
                { key: "gene_id", label: "Gene ID", sortable: true,width:120},
                { key: "gene_name", label: "Gene Name",sortable: true,width:130},
                { key: "source", label: "Source", sortable: true,width:120},
                { key: "pmid", label: "PMID", sortable: true,minWidth:200},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,width:130},
                { key: "map_location", label: "Map location", sortable: true,width:130},
                { key: "chromosome", label: "Chromosome", sortable: true,width:140},
                { key: "probe_position", label: "Probe position", sortable: true,width:150},
                { key: "start", label: "Start", sortable: true,width:95},
                { key: "end", label: "End", sortable: true,width:95},
                
                // { key: "citation", label: "Citation", sortable: true,width:200}
            ],
            metaboliteFields: [
                { key: "metabolite_name", label: "Metabolite", sortable: true,width:200},
                { key: "source", label: "Source", sortable: true,width:100},
                { key: "pmid", label: "PMID", sortable: true,width:120},
                { key: "hmdb", label: "HMDB ID", sortable: true,width:117},
                { key: "kegg", label: "KEGG ID", sortable: true,width:110},
                { key: "pubchem", label: "Pubchem ID",sortable: true,width:130},
                { key: "groups", label: "Groups", sortable: true,minWidth:130},
                { key: "categories", label: "Categories", sortable: true,width:120},
                { key: "organism", label: "Organism", sortable: true,width:110},
                { key: "tissue", label: "Tissue", sortable: true,width:100},
                { key: "regulated", label: "Regulated", sortable: true,width:113},
                
                // { key: "citation", label: "Citation", sortable: true,width:200}
            ], 
            proteinFields: [
                { key: "uniprot_accession", label: "Uniprot accession", sortable: true,width:168},
                { key: "source", label: "Source", sortable: true,width:100},
                { key: "pmid", label: "PMID", sortable: true,width:120},
                { key: "uniprot_entry_name", label: "UniProt entry name", sortable: true,width:175},
                { key: "protein_name", label: "Protein name", sortable: true,width:150},
                { key: "gene_symbol", label: "Gene name",sortable: true,width:130},
                { key: "groups", label: "Groups", sortable: true,minWidth:130},
                { key: "categories", label: "Categories", sortable: true,width:120},
                { key: "organism", label: "Organism", sortable: true,width:110},
                { key: "tissue", label: "Tissue", sortable: true,width:100},
                { key: "regulated", label: "Regulated", sortable: true,width:113},
                
                // { key: "citation", label: "Citation", sortable: true,width:200}
            ], 
            barMDDData: [{
               value: 19443,
               name: "protein"},{
                value:18039,
               name: "metabolite"},{
               value: 501,
               name: "methylation"},{
               value: 369,
               name: "ncRNA"},{
               value: 1396,
               name: "gene"},{
               value: 1474,
               name: "SNP"
            }],
            barMDDTitle:"Omics composition of major depressive disorder data",
            barBDData: [{
               value: 1058,
               name: "ncRNA"},{
               value: 6837,
               name: "gene"},{
               value: 2944,
               name: "SNP"
            }],
            barBDTitle:"Omics composition of bipolar disorder data",
            barSZData: [{
               value: 12098,
               name: "methylation"},{
               value: 662,
               name: "ncRNA"},{
               value: 11478,
               name: "gene"},{
               value: 3131,
               name: "SNP"
            }],
            barSZTitle:"Omics composition of schizophrenia data",
            barAXData: [{
               value: 35,
               name: "ncRNA"},{
               value: 795,
               name: "gene"},{
               value: 169,
               name: "SNP"
            }],
            barAXTitle:"Omics composition of anxiety disorder data",
            barTitle:"",
            barData:[],
            MDDIntroduction:" (MDD here), also known as clinical depression, is one of the most common psychological disorders. Patients with MDD are usually in a depressed emotional state for a long time (more than two weeks). They may be accompanied by physical disorders such as sleep disturbances, palpitations and chest tightness, constipation, and weight loss. MDD patients suffer greatly and are at a high risk of suicide.",
            BDIntroduction:" (BD here), previously known as manic depression, is often misdiagnosed with MDD in the clinic.  Patients with BD have two periods of onset: manic and depressive episodes.  During the manic episode, the patient is high in mood, irritable and has a reduced need for sleep.  During the depressive episode, the patient is depressed, suicidal and is not significantly different from an MDD patient.",
            SZIntroduction:" (SZ here) is a mental disorder characterized by continuous or relapsing episodes of psychosis. The clinical symptoms of schizophrenia are complex and vary significantly between individuals. They may involve disorders in perception, thinking, emotion, volitional behaviour and cognitive function. ",
            AXIntroduction:" (AX here) are characterized by the experience of anxious emotions. People with AX usually feel intense and constant tension, which may be accompanied by symptoms such as increased heart rate and difficulty sleeping. Anxiety disorders contain several types, including generalized anxiety disorder, panic disorder, etc. It can sometimes co-occur with major depressive disorder, bipolar disorder or schizophrenia.",
            nodes:[],
            edges:[],
            inter_edges:[],
        }
    },
    methods:{
        handleClick(tab, event) {
            this.activeOmics=tab.name
            this.currentPage=1
            this.pageSize=10
            this.desc=null
            this.sortby=null
            if(this.activeOmics=='MDD'){
                this.$refs.metaboliteTable.clearSort()
                this.$refs.methylationTable.clearSort()
                this.$refs.proteinTable.clearSort()
            }else if(this.activeDisease=='SZ'){
                this.$refs.methylationTable.clearSort()
            }
            this.$refs.snpTable.clearSort()
            this.$refs.geneTable.clearSort()
            this.$refs.rnaTable.clearSort()
            
            this.getData()
        },
        getData(){
            var tmpID="#"+this.activeOmics;
            var loadingInstance = Loading.service({
                target:document.querySelector(tmpID)
            });
            this.axios.get(this.GLOBAL.rootAddress+'browse/'+this.activeDisease+'/'+this.activeOmics,{
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc
                }
            })
            .then(response=> {
                loadingInstance.close();
                this.totalCount=response.data.data.total;
                this.tableData=response.data.data.records;
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },

        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
            },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        download(){
            this.percentage=0;
            var loadingInstance = Loading.service({
                text:"This may take a few seconds. Please wait. "
            });
            this.axios.get(this.GLOBAL.rootAddress+'download/browse',
                { 
                params: { 
                    'disease': this.activeDisease,
                    'type': this.activeOmics,
                },
                responseType: 'blob',
                }).then((response) => {
                let url = window.URL.createObjectURL(response.data);
                let link = document.createElement('a');
                link.href = url;
                link.download = "MDDOmics_"+this.activeDisease+"_"+this.activeOmics+".xlsx";
                document.body.appendChild(link);
                link.click();
                link.remove(); 
                window.URL.revokeObjectURL(link.href);
                loadingInstance.close();  
            })
        },
        test(){
            this.inter_edges=[];
            this.edges=[];
            this.nodes=[];
            var loadingInstance = Loading.service({
                target:document.querySelector("#plot")
            });
            this.axios.get(this.GLOBAL.rootAddress+'browse/knowledge',{
            params: { 
                'activeDisease': this.activeDisease,
                }
            })
            .then(response=> {
                var knowledge_data=response.data.data
                knowledge_data.edges.forEach((ele)=>{
                    this.edges.push({
                        source: ele.source_type + '_' + ele.source_id,
                        target: ele.target_type + '_' + ele.target_id
                    })
                    // if(ele.source_type!=ele.target_type){
                    //     this.inter_edges.push({
                    //     source: ele.source_type + '_' + ele.source_id,
                    //     target: ele.target_type + '_' + ele.target_id
                    // })
                    // }
                });
                var degrees_full = {};
                this.edges.forEach(edge => {
                    degrees_full[edge.source] = (degrees_full[edge.source] || 1) + 1;
                    degrees_full[edge.target] = (degrees_full[edge.target] || 1) + 1;
                });
                Object.keys(degrees_full).forEach(nodeId => {
                    degrees_full[nodeId] = degrees_full[nodeId]/2+10
                });

                // var degrees_inter = {};
                // this.inter_edges.forEach(edge => {
                //     degrees_inter[edge.source] = (degrees_inter[edge.source] || 1) + 1;
                //     degrees_inter[edge.target] = (degrees_inter[edge.target] || 1) + 1;
                // });
                // Object.keys(degrees_inter).forEach(nodeId => {
                //     degrees_inter[nodeId] = degrees_inter[nodeId]/2+10
                // });

                knowledge_data.snps.forEach((ele) => {
                    this.nodes.push({
                        id:"snp_"+ele.snp_id,
                        name: ele.snp,
                        chromosome:ele.chromosome,
                        position:ele.position,
                        allele:ele.allele,
                        gene:ele.gene,
                        category:'SNP',
                        symbolSize_full:degrees_full["snp_"+ele.snp_id]?degrees_full["snp_"+ele.snp_id]:0,
                        // symbolSize_inter:degrees_inter["snp_"+ele.snp_id]?degrees_inter["snp_"+ele.snp_id]:0
                    });
                });

                knowledge_data.genes.forEach((ele) => {
                    this.nodes.push({
                        id:"gene_"+ele.genetb_id,
                        name: ele.gene_name,
                        gene_id:ele.gene_id,
                        location:ele.map_location,
                        type:ele.gene_type,
                        category:'Gene',
                        symbolSize_full:degrees_full["gene_"+ele.genetb_id]?degrees_full["gene_"+ele.genetb_id]:0,
                        // symbolSize_inter:degrees_inter["gene_"+ele.genetb_id]?degrees_inter["gene_"+ele.genetb_id]:0
                    });
                });

                knowledge_data.methylations.forEach((ele) => {
                    this.nodes.push({
                        id:"methylation_"+ele.methylation_id,
                        name: ele.gene_name,
                        gene_name:ele.gene_name,
                        gene_id:ele.gene_id,
                        probe:ele.probe,
                        location:ele.map_location,
                        category:'Methylation',
                        symbolSize_full:degrees_full["methylation_"+ele.methylation_id]?degrees_full["methylation_"+ele.methylation_id]:0,
                        // symbolSize_inter:degrees_inter["methylation_"+ele.methylation_id]?degrees_inter["methylation_"+ele.methylation_id]:0
                    });
                });
                
                knowledge_data.rnas.forEach((ele) => {
                    var tmpName
                    if(ele.gene_name!=null)tmpName=ele.gene_name
                    else tmpName=ele.rna_name
                    this.nodes.push({
                        id:"ncRNA_"+ele.rnatb_id,
                        name: tmpName,
                        gene_id:ele.gene_id,
                        rna_name:ele.rna_name,
                        location:ele.map_location,
                        type:ele.gene_type,
                        category:'RNA',
                        symbolSize_full:degrees_full["ncRNA_"+ele.rnatb_id]?degrees_full["ncRNA_"+ele.rnatb_id]:0,
                        // symbolSize_inter:degrees_inter["ncRNA_"+ele.rnatb_id]?degrees_inter["ncRNA_"+ele.rnatb_id]:0
                    });
                });
                this.dataReady=true
                loadingInstance.close();
            })
            .catch(error=> {
                console.log(error);
            });
        }

    },
    watch:{
        $route:{
            immediate:true, //url不发生变化，也可以执行的
            handler(newVal,oldVal){
                this.dataReady=false,
                this.activeDisease=this.$route.name; 
                this.test()
                switch(this.activeDisease){
                    case 'MDD':
                        this.activeDiseaseFull='major depressive disorder'
                        this.activeIntroduction=this.MDDIntroduction
                        this.barData=this.barMDDData
                        this.barTitle=this.barMDDTitle
                        break;
                    case 'BD':
                        this.activeDiseaseFull='bipolar disorder'
                        this.activeIntroduction=this.BDIntroduction
                        this.barData=this.barBDData
                        this.barTitle=this.barBDTitle
                        break;
                    case 'SZ':
                        this.activeDiseaseFull='schizophrenia'
                        this.activeIntroduction=this.SZIntroduction
                        this.barData=this.barSZData
                        this.barTitle=this.barSZTitle
                        break;
                    case 'AX':
                        this.activeDiseaseFull='anxiety disorders'
                        this.activeIntroduction=this.AXIntroduction
                        this.barData=this.barAXData
                        this.barTitle=this.barAXTitle
                        break;
                }
                this.activeOmics='snp';
                this.currentPage=1
                this.pageSize=10
                this.desc=null
                this.sortby=null
                this.getData()   
            }
        }
    },
}

</script>
